import {AssetMap} from '../interfaces/interfaces';

export const assetsToLoad: AssetMap = {
  nicaCutted: {
    path: 'nica-cutted.svg',
    loaded: false,
    resource: null
  },
  linkedin: {
    path: 'linkedin.svg',
    loaded: false,
    resource: null
  },
  github: {
    path: 'github.svg',
    loaded: false,
    resource: null
  },
  gitlab: {
    path: 'gitlab.svg',
    loaded: false,
    resource: null
  },
  nicaLogo: {
    path: 'nica-logo.svg',
    loaded: false,
    resource: null
  },
  nicaBackground: {
    path: 'nicaLogo.svg',
    loaded: false,
    resource: null
  },
  marimar: {
    path: 'marimar.svg',
    loaded: false,
    resource: null
  },
  console: {
    path: 'console.svg',
    loaded: false,
    resource: null
  },
  home: {
    path: 'home.svg',
    loaded: false,
    resource: null
  },
  about01: {
    path: 'about01.png',
    loaded: false,
    resource: null
  },
  university: {
    path: 'university.svg',
    loaded: false,
    resource: null
  },
  addvalue: {
    path: 'addvalue.svg',
    loaded: false,
    resource: null
  },
  vas: {
    path: 'vas.svg',
    loaded: false,
    resource: null
  },
  slowmedia: {
    path: 'slowmedia.svg',
    loaded: false,
    resource: null
  },
  eleads: {
    path: 'eleads.svg',
    loaded: false,
    resource: null
  },
  trueblue: {
    path: 'trueblue.svg',
    loaded: false,
    resource: null
  },
  spaceinvaders: {
    path: 'spaceinvaders.svg',
    loaded: false,
    resource: null
  },
  unity: {
    path: 'unity.svg',
    loaded: false,
    resource: null
  },
  unreal: {
    path: 'unreal.svg',
    loaded: false,
    resource: null
  },
  folderIcon: {
    path: 'folderIcon.svg',
    loaded: false,
    resource: null
  },
  devTo: {
    path: 'devTo.svg',
    loaded: false,
    resource: null
  },
  textEditorIcon: {
    path: 'textEditorIcon.svg',
    loaded: false,
    resource: null
  },
  jssheetIcon: {
    path: 'jssheetIcon.svg',
    loaded: false,
    resource: null
  },
  twitterIcon: {
    path: 'twitterIcon.svg',
    loaded: false,
    resource: null
  },
  redditIcon: {
    path: 'redditIcon.svg',
    loaded: false,
    resource: null
  },
  hackernoonIcon: {
    path: 'hackernoonIcon.svg',
    loaded: false,
    resource: null
  },
  socialFolderIcon: {
    path: 'socialFolderIcon.svg',
    loaded: false,
    resource: null
  },
  km_logo1: {
    path: 'k&m/logo-part1.svg',
    loaded: false,
    resource: null
  },
  km_logo2: {
    path: 'k&m/logo-part2.svg',
    loaded: false,
    resource: null
  },
  km_logo3: {
    path: 'k&m/logo-part3.svg',
    loaded: false,
    resource: null
  },
  km_playButton: {
    path: 'k&m/play_button.png',
    loaded: false,
    resource: null
  },
  km_shield: {
    path: 'k&m/shield_icon.png',
    loaded: false,
    resource: null
  },
  km_sword: {
    path: 'k&m/sword_icon.png',
    loaded: false,
    resource: null
  },
  km_sword_r: {
    path: 'k&m/sword_icon_r.png',
    loaded: false,
    resource: null
  },
  km_background01: {
    path: 'k&m/background01.png',
    loaded: false,
    resource: null
  },
  km_background02: {
    path: 'k&m/background02.png',
    loaded: false,
    resource: null
  },
  km_background03: {
    path: 'k&m/background03.png',
    loaded: false,
    resource: null
  },
  random: {
    path: 'random.svg',
    loaded: false,
    resource: null
  },
  polygone_logo: {
    path: 'polygone_logo.svg',
    loaded: false,
    resource: null
  },
  autobattler_logo: {
    path: 'autobattler-logo.svg',
    loaded: false,
    resource: null
  },
  folderIconGame: {
    path: 'folderIconGame.svg',
    loaded: false,
    resource: null
  },
  folderIconApps: {
    path: 'folderIconApps.svg',
    loaded: false,
    resource: null
  },
  folderIconProjects: {
    path: 'folderIconProjects.svg',
    loaded: false,
    resource: null
  },
  scienceIcon: {
    path: 'science-icon.svg',
    loaded: false,
    resource: null
  },
  catIcon: {
    path: 'cat-icon.svg',
    loaded: false,
    resource: null
  },
  beerIcon: {
    path: 'beer-icon.svg',
    loaded: false,
    resource: null
  },
  mountainIcon: {
    path: 'mountain-icon.svg',
    loaded: false,
    resource: null
  },
  italianLogo: {
    path: 'italian-logo.png',
    loaded: false,
    resource: null
  },
  youtube: {
    path: 'youtube.svg',
    loaded: false,
    resource: null
  },
  itch: {
    path: 'itch.io.svg',
    loaded: false,
    resource: null
  },
  codingame: {
    path: 'codingame.svg',
    loaded: false,
    resource: null
  }
};
